(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = this.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      const bottom = this.headerWrapper ? this.headerWrapper.getBoundingClientRect().bottom : this.header.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--header-bottom-position', `${bottom}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.setHeaderHeight();

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const nav = document.querySelector('.section-header .header__category-nav');
    if (!nav) return;

    const itemsWithMega = Array.from(nav.querySelectorAll('.header__category-item')).filter((item) =>
      item.querySelector('.header__category-mega')
    );
    if (!itemsWithMega.length) return;

    let closeTimer = null;
    const CLOSE_DELAY = 220;
    const notifyOverlayStateCheck = () => {
      document.dispatchEvent(new CustomEvent('overlayHeaderStateCheck'));
    };

    const closeAll = () => {
      itemsWithMega.forEach((item) => item.classList.remove('is-open'));
      notifyOverlayStateCheck();
    };

    const scheduleClose = (item) => {
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (item) {
          item.classList.remove('is-open');
          notifyOverlayStateCheck();
        } else {
          closeAll();
        }
      }, CLOSE_DELAY);
    };

    itemsWithMega.forEach((item) => {
      const trigger = item.querySelector('.header__category-link');
      const mega = item.querySelector('.header__category-mega');
      const previewItems = Array.from(item.querySelectorAll('[data-mega-preview-item]'));
      const previewTriggers = Array.from(item.querySelectorAll('[data-mega-preview-key]'));
      const defaultPreview = previewItems.find((preview) => preview.dataset.megaPreviewItem === '__default');

      const setActivePreview = (key) => {
        if (!previewItems.length) return;

        const activePreview =
          (key && previewItems.find((preview) => preview.dataset.megaPreviewItem === key)) ||
          defaultPreview ||
          previewItems[0];
        if (!activePreview) return;

        previewItems.forEach((preview) => {
          preview.classList.toggle('is-active', preview === activePreview);
        });
      };

      const resetActivePreview = () => {
        setActivePreview('__default');
      };

      previewTriggers.forEach((previewTrigger) => {
        previewTrigger.addEventListener('mouseenter', () => {
          setActivePreview(previewTrigger.dataset.megaPreviewKey);
        });

        previewTrigger.addEventListener('mouseleave', () => {
          resetActivePreview();
        });

        previewTrigger.addEventListener('focus', () => {
          setActivePreview(previewTrigger.dataset.megaPreviewKey);
        });

        previewTrigger.addEventListener('blur', () => {
          resetActivePreview();
        });
      });

      if (trigger) {
        trigger.addEventListener('mouseenter', () => {
          if (closeTimer) window.clearTimeout(closeTimer);
          closeAll();
          resetActivePreview();
          item.classList.add('is-open');
        });

        trigger.addEventListener('focus', () => {
          if (closeTimer) window.clearTimeout(closeTimer);
          closeAll();
          resetActivePreview();
          item.classList.add('is-open');
        });
      }

      item.addEventListener('mouseenter', () => {
        if (closeTimer) window.clearTimeout(closeTimer);
        closeAll();
        resetActivePreview();
        item.classList.add('is-open');
      });

      item.addEventListener('mouseleave', (event) => {
        const relatedTarget = event.relatedTarget;
        if (relatedTarget && item.contains(relatedTarget)) return;

        if (mega && relatedTarget instanceof Element) {
          const megaRect = mega.getBoundingClientRect();
          const nextX = event.clientX;
          const nextY = event.clientY;
          const tolerance = 24;
          const isNearMega =
            nextX >= megaRect.left - tolerance &&
            nextX <= megaRect.right + tolerance &&
            nextY >= megaRect.top - tolerance &&
            nextY <= megaRect.bottom + tolerance;
          if (isNearMega) return;
        }

        scheduleClose(item);
      });

      if (mega) {
        mega.addEventListener('mouseenter', () => {
          if (closeTimer) window.clearTimeout(closeTimer);
          item.classList.add('is-open');
        });

        mega.addEventListener('mouseleave', (event) => {
          const relatedTarget = event.relatedTarget;
          if (relatedTarget && item.contains(relatedTarget)) return;

          if (trigger && relatedTarget instanceof Element) {
            const triggerRect = trigger.getBoundingClientRect();
            const nextX = event.clientX;
            const nextY = event.clientY;
            const tolerance = 24;
            const isNearTrigger =
              nextX >= triggerRect.left - tolerance &&
              nextX <= triggerRect.right + tolerance &&
              nextY >= triggerRect.top - tolerance &&
              nextY <= triggerRect.bottom + tolerance;
            if (isNearTrigger) return;
          }

          scheduleClose(item);
        });
      }

    });

    nav.addEventListener('mouseenter', () => {
      if (closeTimer) window.clearTimeout(closeTimer);
    });

    nav.addEventListener('mouseleave', () => {
      scheduleClose();
    });

    window.addEventListener(
      'scroll',
      () => {
        if (itemsWithMega.some((item) => item.classList.contains('is-open'))) {
          closeAll();
        }
      },
      { passive: true }
    );

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAll();
      }
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const overlayHeader = document.querySelector('.section-header .header-wrapper--overlay-home');
    if (!overlayHeader) return;

    document.body.classList.add('has-overlay-home-header');

    const scrollTrigger = Number(overlayHeader.dataset.overlayScrollTrigger || 60);
    const hoverEnabled =
      overlayHeader.dataset.overlayHover === 'true' &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    const hasOpenDisclosure = () => Boolean(overlayHeader.querySelector('details[open]'));
    const hasOpenMega = () => Boolean(overlayHeader.querySelector('.header__category-item.is-open'));
    const updateOverlayMetrics = () => {
      const announcementBar = document.querySelector('.announcement-bar-section .utility-bar');
      const announcementHeight = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
      const headerRect = overlayHeader.getBoundingClientRect();
      document.documentElement.style.setProperty('--overlay-announcement-height', `${Math.max(announcementHeight, 0)}px`);
      document.documentElement.style.setProperty('--overlay-header-bottom', `${Math.max(headerRect.bottom, 0)}px`);
    };

    let lastOverlayActive = null;
    let overlayStateRaf = null;

    const applyOverlayState = () => {
      const active =
        window.scrollY > scrollTrigger ||
        hasOpenDisclosure() ||
        hasOpenMega() ||
        (hoverEnabled && overlayHeader.matches(':hover'));

      if (active !== lastOverlayActive) {
        overlayHeader.classList.toggle('is-active', active);
        document.body.classList.toggle('overlay-home-header-active', active);
        lastOverlayActive = active;
      }

      updateOverlayMetrics();
    };

    const queueApplyOverlayState = () => {
      if (overlayStateRaf !== null) return;
      overlayStateRaf = window.requestAnimationFrame(() => {
        overlayStateRaf = null;
        applyOverlayState();
      });
    };

    if (hoverEnabled) {
      overlayHeader.addEventListener('mouseenter', queueApplyOverlayState);
      overlayHeader.addEventListener('mouseleave', queueApplyOverlayState);
    }

    document.addEventListener('overlayHeaderStateCheck', queueApplyOverlayState);

    const disclosureDetails = overlayHeader.querySelectorAll('details');
    disclosureDetails.forEach((detailsEl) => {
      detailsEl.addEventListener('toggle', () => {
        queueApplyOverlayState();
      });
    });

    overlayHeader.addEventListener('focusin', queueApplyOverlayState, true);

    overlayHeader.addEventListener(
      'focusout',
      () => {
        queueApplyOverlayState();
      },
      true
    );

    window.addEventListener('scroll', queueApplyOverlayState, { passive: true });
    window.addEventListener('resize', queueApplyOverlayState);
    applyOverlayState();
  });


  } catch(e) { console.error(e); }
})();
})();
